"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const runEvent_1 = require("../../../app/dist/runEvent");
const removeStep_1 = require("../../../app/dist/removeStep");
exports.toolDef = {
    name: 'loom_remove_step',
    description: 'Remove a pending step from a plan by its stable id. Rejects a done/cancelled step (immutable history). Strips any blockedBy references to the removed step from the surviving steps (no dangling blocker) and reports which steps were re-threaded; recomputes order and prunes the step\'s body detail section. Allowed on draft/active/implementing/blocked plans. Use this tool to remove steps — do not edit plan files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            planId: { type: 'string', description: 'Plan id (ULID e.g. "pl_01J…" or filename stem).' },
            stepId: { type: 'string', description: 'The stable id of the step to remove (the `id` field in the steps frontmatter).' },
        },
        required: ['planId', 'stepId'],
    },
};
async function handle(root, args) {
    const planId = args['planId'];
    const stepId = args['stepId'];
    const loadWeaveStrict = async (r, w) => {
        const result = await (0, dist_1.loadWeave)(r, w);
        if (!result)
            throw new Error(`Weave not found: ${w}`);
        return result;
    };
    const deps = {
        loadWeave: loadWeaveStrict,
        runEvent: (weaveId, event) => (0, runEvent_1.runEvent)(weaveId, event, { loadWeave: loadWeaveStrict, saveDocs: dist_1.saveDocs, loomRoot: root }),
        loomRoot: root,
    };
    const result = await (0, removeStep_1.removeStep)({ planId, stepId }, deps);
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
